import { useSelector } from 'react-redux';
import { canUseVoip } from 'resources/Organization/Features/FeaturesData';

import { fetchOrganizationFeaturesGracefully } from 'components/Account/Voice/VoiceData';

import { useDataFetcherV2 } from '../components/Common/Data/useDataFetcher';

export const useVoip = () => {
  const hasVoipFeature = useSelector(canUseVoip);
  const [organizationLoaded, _] = useDataFetcherV2(fetchOrganizationFeaturesGracefully);
  return [organizationLoaded, hasVoipFeature];
};
